/**
 * The burr toast's element.  packages/engine/src/burrs.js's BurrCue is handed it by
 * context.js and drives show/sting off the local tangle and the server's
 * word; burr.css says why it borrows #charge's slot and entry/exit.
 */
import "./burr.css";
import { mount } from "./dom.js";

export function mountBurr() {
  return mount(`
<!-- Tangled in a burr bush; packages/engine/src/burrs.js drives it.  "jump" rather
     than "Space" because the same words have to be true under a thumb on
     the touch pad.  aria-live assertive: a reader should hear why the
     controls just went heavy, immediately. -->
<div id="burr" class="panel" aria-live="assertive"><b>Burrs!</b><span>mash jump to wriggle free</span></div>`);
}
